/**
 * Swiper (slider) init
 */

if (document.querySelectorAll('.swiper-container').length) {
  try {
    var swiper = new Swiper ('.swiper-container', {

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });
  } catch (e) {
    console.log(e);
  }
}
